// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cargo-cascader[data-v-c41b51d0]  {\n  width: 100%;\n}\n.cargo-cascader[data-v-c41b51d0]  .el-cascader {\n    width: 100%;\n}\n.cargo-cascader[data-v-c41b51d0]  .el-cascader.can-copy .el-input__suffix {\n      right: 18px !important;\n}\n", ""]);
// Exports
module.exports = exports;
